import React, { Component } from 'react';
import _, { isEmpty, size } from 'lodash';
import axios from 'axios';

import { Alert, Avatar, Box, Button, Card, CardHeader, Divider, Grid, IconButton, List, ListItem, ListItemAvatar, ListItemSecondaryAction, ListItemText, Typography } from '@mui/material';
import { CheckCircleOutlined, ChevronRightOutlined, ErrorOutlined, ExpandLess, ExpandMore, InfoOutlined, ReplayOutlined, SyncOutlined } from '@mui/icons-material';

import Dialog from '../../../common/Dialog';
import Attribution from '../Forms/Attribution';
import EquipementDemandBL from './EquipementDemandBL';
import EquipDemandUpdateLine from '../../../EmployeeView/EquipementDemands/EquipDemandUpdateLine';

class LoanDemandSingle extends Component {
    state = {  
        user: {},
        loan: {},
        index: 0,
        details: [],
        defaultItemDemand: {},
        openAttribute: false,
        total: 0,
        max:{},
        currentForm: "",
        currentIndex: 1,
        currentLine: {},
        LOAN_LIST: [],
        isChecked: {},
        demand_files: null
    }
    componentDidMount = () => {

        // if (isEmpty(this.props.LOAN_DEMANDS[this.props.DEMAND.demand_loan_id])){
        //     await this.props.fetchLoanDemandDetails(this.props.DEMAND.demand_loan_id)
        //     // or axios

        // }

        this.fetchDetails()
        if(!this.props.STATE.equipements.fetched ){
            this.props.fetchEquipements()
        }
        if(!this.props.STATE.vehicules.fetched ){
            this.props.fetchVehicules()
        }

    }
    fetchDetails = async () => {
        const res = await axios.post("/loans/demands/details", {demandID: this.props.DEMAND.demand_loan_id}) 
        if (res.data) {
            if (res.data.error) {
                console.log('==== get Demand Details ================');
                console.log(res.data.error);
                console.log('====================================');
            } else {
                let total = 0
                let max = {}
                let totalRest = 0

                res.data.forEach( info => {
                    total += info.demand_line.line_quantity
                    totalRest += info.rest
                    max[info.demand_line.line_equipement] = info.rest
                    // max[info.demand_line.line_equipement] = size(info.available) > info.rest ? info.rest : size(info.available)
                })
                this.setState({
                    details: res.data,
                    total,
                    totalRest,
                    user: this.props.USERS[this.props.DEMAND.demand_user],
                    max
                })
            }
        } else {
            console.log('==== get Demand Details ================');
            console.log("no Response");
            console.log('====================================');
        }
    }
    fetchLoanList = async (equipID) => {
        const res = await axios.post("/loans/demand/list", {demandID: this.props.DEMAND.demand_loan_id}) 
        let displaySubmit = false
        if (res.data) {
            if (res.data.error) {
                console.log('==== get Demand Details ================');
                console.log(res.data.error);
                console.log('====================================');
            } else {
                let isChecked = {}
                res.data.filter(loan => loan.loan_status != "RESA_CANCELED").forEach(item => isChecked[item.loan_id] = false)
                if (res.data.filter(loan => loan.loan_status != "RESA_CANCELED").every(loan => loan.loan_status === "RESA_READY") && this.props.DEMAND.demand_status == "DEMAND_VALIDATE") {
                    console.log('====================================');
                    console.log("AALL validate");
                    console.log('====================================');
                    displaySubmit = true
                }
                this.setState({
                   LOAN_LIST: res.data,
                   isChecked,
                   displaySubmit
                })
            }
        } else {
            console.log('==== get Demand Details ================');
            console.log("no Response");
            console.log('====================================');
        }
    }
    handleNextForm = async () => {
        const { max, currentForm, currentIndex } = this.state;

        // await this.fetchDetails()
        
        this.handleClose()
        // if (max[currentForm] < (currentIndex + 1) ){
        // } else {
        //     let nextEquip = await this.fetchDetails()
        //     this.setState({
        //         currentIndex: currentIndex + 1,
        //         defaultItemDemand : this.state.currentLine.available[0], // === current index - 1
        //     })
        //     window.scrollTo(0, 0);
        // }
    }
    handleClose = async () => {
        this.setState({
            openAttribute: false, 
            openAttributeFinal: false, 
            addEquipements: false, 
            defaultItemDemand: {} ,
            savedLoan: {} ,
            currentForm: "",
            openConfirm: false,
            currentIndex: 1,
        })
        await this.fetchDetails()
    }
    
    handleSubmit = async () => {
        // if all line rest == 0 && demand.status = "DEMAND_WAITING"
        const { totalRest } = this.state;
        if (totalRest == 0 && this.props.DEMAND.demand_status === "DEMAND_WAITING") {
            // this.props.updateLoanDemandStatus()
            // const res = await axios.post("/loans/demands/update/status", {demandID: this.props.DEMAND.demand_loan_id})
            await this.props.updateDemandLoanStatus(this.props.DEMAND, "validate")
            if(this.props.STATE.loanDemands.error){
                this.props.notif("error",`Un problème est survenu: ${this.props.STATE.loanDemands.error}`)
            } else { 
                this.props.notif("success", "Enregistré")
            } 
            
        } else if(this.props.DEMAND.demand_status === "DEMAND_VALIDATE" || this.props.DEMAND.demand_status === "DEMAND_READY") {
            this.setState({
                openConfirm: true
            })
        }
    }

    handleSubmitStatus =  async () => {
        if (this.props.DEMAND.demand_status === "DEMAND_VALIDATE") {
            await this.props.updateDemandLoanStatus(this.props.DEMAND, "ready")
            if(this.props.STATE.loanDemands.error){
                this.props.notif("error",`Un problème est survenu: ${this.props.STATE.loanDemands.error}`)
            } else { 
                this.props.notif("success", "Enregistré")
                this.handleClose()
            }
        } else if (this.props.DEMAND.demand_status === "DEMAND_READY") {
            // add file
            let demand = Object.assign({}, this.props.DEMAND)
            demand.demand_status = "DEMAND_PICKED_UP"
            demand.demand_files = this.state.demand_files
            await this.props.updateDemandLoanStatus(demand, "pickup")
            if(this.props.STATE.loanDemands.error){
                this.props.notif("error",`Un problème est survenu: ${this.props.STATE.loanDemands.error}`)
            } else { 
                this.props.notif("success", "Enregistré")
                this.handleClose()
            }
        }
    }

    handleAttributeFinal = (loan) => {
        const { USERS, DEMAND } = this.props;
        this.setState({ 
            openAttributeFinal: true, 
            savedLoan:loan,
            user: USERS[DEMAND.demand_user],
            // defaultItemDemand : infos.available[0],
            // demand_line : infos.demand_line,
            // currentForm : infos.demand_line.line_equipement,
            // currentLine : infos,
        }) 
    }
    
    handleCloseAttributeFinal = async () => {
        this.setState({
            openAttributeFinal: false, 
            savedLoan: {} ,
        })
        await this.fetchLoanList()
    }
    handleChecked = (event) => {
        const { checked, name } = event.target;
        let isChecked = Object.assign({}, this.state.isChecked)
        isChecked[name] = checked
        let displaySubmit = false
        if (Object.values(isChecked).every(checked => checked === true)) {
            console.log('====================================');
            console.log("AALL CHECKED");
            console.log('====================================');
            displaySubmit = true
        }
        this.setState({
            isChecked,
            displaySubmit
        });
    };

    handleDeleteLoan = async (loan) => {
        let newLoan = Object.assign({}, loan)
        newLoan.loan_status = "RESA_CANCELED"
        await this.props.updateResaLoanAdmin(newLoan)
        // notif success
        if(this.props.STATE.loans.error){
            this.props.notif("error",`Un problème est survenu: ${this.props.STATE.loans.error}`)
        } else { 
            this.props.notif("success", "Equipement Supprimé")
            await this.fetchLoanList()
        }
    }
    render() {
        const { DEMAND, LOAN_DEMANDS, EQUIPEMENTS, USERS } = this.props;
        const {  openAttribute, openAttributeFinal,  defaultItemDemand, details, user, demand_line, currentIndex, currentForm, totalRest, openBL, openConfirm, displaySubmit, savedLoan } = this.state;

        const DEMAND_TITLE = {
            "DEMAND_WAITING": "Valider",
            // "DEMAND_UPDATED": "Valider",
            "DEMAND_VALIDATE": "Commande Prete",
            "DEMAND_READY": "Remettre",
            // "DEMAND_PICKED_UP": "",
        }
        // let list = this.filterList()
        console.log('====================================');
        console.log(this.state);
        console.log({DEMAND});
        console.log('====================================');
        return (
            <Dialog
                close={this.props.handleCloseAll}
                maxWidth="lg"
                fullScreen
                scroll="paper"
                title={`${USERS[DEMAND.demand_user].lastname}  ${USERS[DEMAND.demand_user].username} — Demande du ${new Date(DEMAND.demand_creation_date).toLocaleDateString("fr-FR")} `}
                submitAction={DEMAND_TITLE[DEMAND.demand_status] && this.handleSubmit}
                submitTitle={DEMAND_TITLE[DEMAND.demand_status]}
                disabledSubmit={
                    (totalRest > 0 || 
                        (!displaySubmit && DEMAND.demand_status === "DEMAND_VALIDATE" ) || 
                        (!displaySubmit && DEMAND.demand_status === "DEMAND_READY" ) ||
                        (isEmpty(this.state.demand_files) && DEMAND.demand_status === "DEMAND_READY" ) 
                    )
                }
                appBar
            >
                {openConfirm &&
                    <Dialog
                        appBar
                        appBarColor="primary"
                        title={
                            DEMAND.demand_status == "DEMAND_VALIDATE" ? 
                            "Confirmer la préparation" : 
                            `${USERS[DEMAND.demand_user].lastname} ${USERS[DEMAND.demand_user].username} — Remise du matériel`
                        }
                        submitAction={this.handleSubmitStatus}
                        submitTitle={DEMAND_TITLE[DEMAND.demand_status]}
                        close={() => this.setState({ openConfirm: false})}
                    >
                        {DEMAND.demand_status == "DEMAND_VALIDATE" ?
                            <Box p={1}>
                                Une fois confirmé, l'utilisateur sera notifié que sa commande est prête
                            </Box>
                        :
                            <Box p={1}>
                                <Alert severity="info">
                                    Confirmer la remise de <b>{this.state.total} articles</b>
                                </Alert>
                            </Box>
                        }
                    </Dialog>
                }
                {openAttribute && !isEmpty(user) && !isEmpty(defaultItemDemand) &&
                    <Attribution
                        handleClose={this.handleClose}
                        handleNext={this.handleNextForm}
                        defaultItemDemand={defaultItemDemand}
                        user={user}
                        demand_line={demand_line}
                        start_date={DEMAND.demand_start_date}
                        end_date={DEMAND.demand_end_date}
                        max={this.state.max[currentForm]}
                        currentIndex={currentIndex}
                        {...this.props}
                        resa
                    />
                }
                {openAttribute && !isEmpty(user) && isEmpty(defaultItemDemand) &&
                    <Attribution
                        handleClose={this.handleClose}
                        handleNext={this.handleNextForm}
                        user={user}
                        demand_line={demand_line}
                        start_date={DEMAND.demand_start_date}
                        end_date={DEMAND.demand_end_date}
                        max={this.state.max[currentForm]}
                        currentIndex={currentIndex}
                        {...this.props}
                        resa
                    />
                }
                {openAttributeFinal && !isEmpty(user) && !isEmpty(savedLoan) &&
                    <Attribution
                        handleClose={this.handleCloseAttributeFinal}
                        handleNext={this.handleCloseAttributeFinal}
                        savedLoan={savedLoan}
                        user={user}
                        demand_line={demand_line}
                        max={this.state.max[currentForm]}
                        currentIndex={currentIndex}
                        {...this.props}
                        final
                    />
                }
                {this.state.addEquipements &&

                    <EquipDemandUpdateLine
                        {...this.props}
                        handleClose={this.handleClose}
                        admin
                    />
                }
                <Box>
                    {/* <Card> */}
                    {DEMAND.demand_status == "DEMAND_UPDATED" &&
                        <Box p={1}>
                            <Alert severity="warning">
                                <Typography variant="h6"><b>En attente de la validation de {USERS[DEMAND.demand_user].username}</b></Typography>
                            </Alert>
                        </Box>
                    }
                    {DEMAND.demand_status == "DEMAND_WAITING"  ?
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={4}>
                                <Box p={3} style={{ borderRight : "1px solid lightgray"}}>
                                    <Box p={1} style={{display: "flex", justifyContent: "space-between"}}>
                                        Date d'emprunt souhaitée : 
                                        <b> {new Date(DEMAND.demand_start_date).toLocaleDateString("fr-FR")}</b>
                                    {/* <Typography variant="button" > */}
                                    {/* </Typography> */}
                                    </Box>
                                    {/* <Divider /> */}
                                    <Box p={1} style={{display: "flex", justifyContent: "space-between"}}>
                                        Date de fin prévue : 
                                        <b> {new Date(DEMAND.demand_end_date).toLocaleDateString("fr-FR")}</b>
                                    {/* <Typography variant="button" > */}
                                    {/* </Typography> */}
                                    </Box>
                                    <Box p={1} style={{display: "flex", justifyContent: "space-between"}}>
                                        Durée : 
                                        <b> {(new Date(DEMAND.demand_end_date) - new Date(DEMAND.demand_start_date))/1000/60/60/24 } jours</b>
                                    {/* <Typography variant="button" > */}
                                    {/* </Typography> */}
                                    </Box>
                                    {/* <Divider /> */}
                                    <Box p={1} style={{display: "flex", justifyContent: "space-between"}}>
                                        Nombre total d'articles: 
                                        <b> {this.state.total}</b>
                                    </Box>
                                    <Box p={1} style={{display: "flex", justifyContent: "space-between"}}>
                                        Usage prévu: 
                                        <b> {DEMAND.demand_remarks}</b>
                                    </Box>
                                    {/* <Divider /> */}

                                </Box>
                            </Grid>
                            <Grid item xs={12} sm={8}>
                                <CardHeader 
                                    subheader="Liste des Matériels" 
                                />
                                <Box p={2}>
                                    <List>
                                        {!isEmpty(details) && details.map((infos, i) =>
                                        <>
                                            <ListItem 
                                                alignItems="flex-start"
                                                // style={{background:(i % 2 === 0 ? "rgb(224 247 250 / 60%)" : "white")}}
                                                key={infos.equipement.equipement_id}
                                            >
                                                <ListItemAvatar>
                                                    <Avatar variant="rounded" alt={infos.equipement.equipement_original_name} src={`/photos/single/${infos.equipement.equipement_photo_front.filename}`} />
                                                </ListItemAvatar>
                                                <ListItemText
                                                    primary={
                                                        <React.Fragment>
                                                            <Typography
                                                                sx={{ display: 'inline' }}
                                                                component="span"
                                                                variant="h5"
                                                                color="primary"
                                                            >
                                                                <b>{infos.rest} </b>
                                                            </Typography>
                                                            <Typography
                                                                sx={{ display: 'inline' }}
                                                                component="span"
                                                                variant="h6"
                                                                color="text.primary"
                                                            >
                                                                / {infos.demand_line.line_quantity} x {infos.equipement.equipement_original_name}
                                                            </Typography>
                                                            <Typography
                                                                // component="span"
                                                                variant="body1"
                                                                color="text.secondary"
                                                            >
                                                                {" "}{infos.equipement.equipement_brand}
                                                            </Typography>
                                                                                                                    
                                                        </React.Fragment>
                                                    }
                                                    secondary={
                                                        <React.Fragment>
                                                            <Typography
                                                                sx={{ display: 'inline' }}
                                                                component="span"
                                                                variant="body1"
                                                                color="text.primary"
                                                            >
                                                                <i>{" — "}{infos.demand_line.line_remarks}</i>
                                                            </Typography>
                                                            <br />
                                                            {infos.rest > 0 ?
                                                                <Alert severity={size(infos.available) >= infos.rest ? "success" : "error"}>
                                                                {" Disponible: "}{size(infos.available)}
                                                                </Alert>
                                                            :
                                                                <Alert severity="info">
                                                                    Validé
                                                                </Alert>
                                                            }
                                                        </React.Fragment>
                                                    }
                                                />
                                                {infos.rest > 0 &&
                                                    <>
                                                        {/* {size(infos.available) >= infos.rest ? */}
                                                            <IconButton
                                                                style={{margin: "auto"}}
                                                                onClick={() => this.setState({ 
                                                                    openAttribute: true, 
                                                                    defaultItemDemand : infos.available[0],
                                                                    demand_line : infos.demand_line,
                                                                    currentForm : infos.demand_line.line_equipement,
                                                                    currentLine : infos,
                                                                    // user: USERS[DEMAND.demand_user]
                                                                }) }
                                                                size="large"
                                                                title="Attribuer"
                                                            >
                                                                <ChevronRightOutlined color="success" />
                                                            </IconButton>
                                                        {/* :
                                                        // ELSE opt:
                                                        //     LOAN ALL DISPO
                                                        //     THEN
                                                        //     REPLACE WITH ...
                                                        <>
                                                            <IconButton
                                                                style={{margin: "auto"}}
                                                                onClick={() => this.setState({ 
                                                                    openAttributeReplace: true, 
                                                                    demand_line : infos.demand_line,
                                                                    currentForm : infos.demand_line.line_equipement,
                                                                    currentLine : infos,
                                                                    // user: USERS[DEMAND.demand_user]
                                                                }) }
                                                                size="large"
                                                                title="Remplacer"
                                                            >
                                                                <SyncOutlined color="warning" />
                                                            </IconButton>
                                                        </>
                                                        }    */}
                                                    </>
                                                }
                                            </ListItem>
                                            <Divider />
                                        </>
                                        )}
                                        
                                    </List>
                                </Box>
                                <Box p={1} style={{textAlign: "center"}}>
                                    <Button 
                                        variant="contained"
                                        onClick={() => this.setState({addEquipements: true})}
                                    >
                                        Ajouter des Équipements
                                    </Button>
                                </Box>
                            </Grid>
                        </Grid>
                        :
                        <EquipementDemandBL
                            totalArticles={this.state.total}
                            DEMAND={DEMAND}
                            // LOANS={this.props.LOANS}
                            // details={this.state.details}
                            title={`${USERS[DEMAND.demand_user].lastname}  ${USERS[DEMAND.demand_user].username} — Demande du ${new Date(DEMAND.demand_creation_date).toLocaleDateString("fr-FR")} `}
                            closeBL={() => this.setState({ openBL: false})}
                            handleAttributeFinal={this.handleAttributeFinal}
                            fetchLoanList={this.fetchLoanList}
                            handleChecked={this.handleChecked}
                            handleDeleteLoan={this.handleDeleteLoan}
                            {...this.state}
                            setFiles={(files) => this.setState({ demand_files: files})}
                        />
                    }
                    {/* </Card> */}

                </Box>

            </Dialog>
        );
    }
}

export default LoanDemandSingle;